import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({
  name: "auth",
  namespaced: true
})
export class AuthStore extends VuexModule {
  public login: string = "";

  public msg: string = "";

  @Mutation
  setLogin(login: string) {
    this.login = login;
  }

  @Mutation
  setMsg(msg: string) {
    this.msg = msg;
  }
}
